import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'mj-mojob-text-field',
  templateUrl: './mojobTextField.component.html',
  styleUrls: ['./mojobTextField.component.scss'],
})
export class MojobTextFieldComponent {
  @Input() placeholder: string = '';
  @Input() formatHint: string = '';
  @Input() text: string = '';
  @Input() textValidation: any;
  @Input() inputType: string = 'email';
  @Input() state: string = 'INACTIVE';
  @Input() error: string = '';
  @Input() mojobTextFieldId = '';

  @Output() didFocus: EventEmitter<string> = new EventEmitter<string>();
  @Output() leftFocus: EventEmitter<string> = new EventEmitter<string>();
  @Output() onInput: EventEmitter<string> = new EventEmitter<string>();
  @Output() onAddressSet: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() inputChanged: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('mojobTextFieldContainer', { static: true })
  mojobTextFieldContainer: ElementRef;

  inputOnFocus() {
    this.state = 'FOCUS';
    this.didFocus.emit(this.mojobTextFieldId);
  }

  inputOffFocus() {
    this.state = 'INACTIVE';
    this.leftFocus.emit(this.mojobTextFieldId);
  }

  validateText() {
    return this.textValidation(this.text);
  }

  inputOnInput() {
    this.onInput.emit(this.text);
  }

  didSetAddress(place: Object) {
    this.onAddressSet.emit(place);
  }

  onInputChange(text) {
    this.inputChanged.emit(text);
  }
}
